<template>
  <PalettePicker
    class="d-flex align-items-center cursor-pointer"
    :data="value"
    title="Icon Color"
    v-b-tooltip.hover
    @input="onChange"
  >
    <template v-slot:icon>
      <div
        class="d-flex align-items-center"
        style="z-index: 1; font-size: 14px"
      >
        <i class="fas fa-fill-drip"></i>
      </div>
    </template>
  </PalettePicker>
</template>

<script>
import PalettePicker from "@components_system/Shared/Tools/PalettePicker/PalettePicker";

export default {
  components: {
    PalettePicker,
  },
  props: {
    value: {
      default: '#000000',
    }
  },
  methods: {
    onChange(value) {
      this.$emit('change', value);
    }
  },
};
</script>
